import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  warehouses: [],
  selectedWarehouse: null,
  holidays: [],
  isLoading: false,
  readyByResult: null,
};

const holidaySlice = createSlice({
  name: 'holiday',
  initialState,
  reducers: {
    setHolidayLoading(state, action) {
      state.isLoading = action.payload;
    },
    setWarehouseList(state, action) {
      state.warehouses = action.payload || [];
    },
    setSelectedWarehouse(state, action) {
      state.selectedWarehouse = action.payload;
    },
    setHolidayList(state, action) {
      state.holidays = action.payload || [];
      state.isLoading = false;
    },
    setReadyByResult(state, action) {
      state.readyByResult = action.payload;
    },
  },
});

export const {
  setHolidayLoading,
  setWarehouseList,
  setSelectedWarehouse,
  setHolidayList,
  setReadyByResult,
} = holidaySlice.actions;

export default holidaySlice.reducer;
